export class AppConstants {
  public static get urlServer(): string {
    return 'https://complaints-service.tqe.mx/';
  }
}
